<template>
    <CCard>
        <CCardHeader>Настройки цены доставки</CCardHeader>
        <CCardBody>
            <CRow class="mt-3"> 
                <CCol
                    tag="label"
                    class="col-form-label">
                    Показывать календарь
                </CCol>
                <CCol>
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="settings.show_calendar" />
                </CCol>
            </CRow>
        </CCardBody>

        <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="save"
            >Сохранить</CButton>
            <CButton
                color="primary"
                class="mr-3"
                @click="goBack"
            >Отмена</CButton>
        </CCardFooter>
            
    </CCard>

</template>

<script>
    export default {
        name: 'DeliverySettings',
        props: {
            entityType: {
                type: String,
                default: ''
            },
        },
  
        data () {
            return {
                settings: {
                    id: null,
                    entity_type: '',
                    entity_id: '',
                    show_calendar: false,
                },
            }
        },
    
        async mounted() {
            await this.fetch();
        },
        
        methods: {

            async fetch() {
                console.log(this.entityType, 'entityType');
                const { id } = this.$route.params || null;
                console.log(id, 'id');
                const settings = await this.axios.get(`/delivery-settings/${this.entityType}`, { params: { entity_id: id, entity_type: this.entityType } });
                console.log(settings, 'settings')
                if (settings?.data?.id) {
                    this.settings = settings.data;
                }
            },

            async save() {
                try {
                    this.settings.entity_type = this.entityType;
                    this.settings.entity_id = this.$route.params.id || null;
                    this.settings.show_calendar = !!this.settings.show_calendar;
                    await this.axios.post(`/delivery-settings/${this.settings.entity_type}`, this.settings);
                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Не удалось сохранить настройки доставки: ' + error);
                }
            },
            goBack() {
                this.$router.go(-1);
            }
        }
    }
</script>
